import Header from "@/components/Header";
import Footer from "@/components/Footer";

const LAST_UPDATED = "February 20, 2026";

export default function RefundPolicy() {
    return (
        <div className="min-h-screen bg-black text-white" data-testid="refund-policy-page">
            <Header />
            <main className="max-w-4xl mx-auto px-6 sm:px-10 py-16">
                <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#FF3B30] mb-3">
                    LEGAL
                </div>
                <h1 className="font-anton text-4xl sm:text-5xl uppercase leading-[0.95] mb-2">
                    Refund Policy
                </h1>
                <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40 mb-10">
                    LAST UPDATED · {LAST_UPDATED}
                </div>

                <div className="prose prose-invert max-w-none space-y-6 text-white/80 font-sans leading-relaxed">
                    <p>
                        We want you happy with what you pay for. This page explains exactly when
                        and how to get a refund.
                    </p>

                    <h2 className="font-anton text-2xl uppercase text-white mt-10">HPM Courtroom $99 Founding-Member Presale</h2>
                    <ul className="list-disc pl-6 space-y-2">
                        <li><strong>30-day no-questions-asked refund.</strong> Email <a className="text-[#FF3B30] underline" href="mailto:hello@alphacovenantholdings.com">hello@alphacovenantholdings.com</a> within 30 days of your $99 charge and we will refund the full amount within 5–10 business days.</li>
                        <li><strong>18-month launch guarantee.</strong> If HPM Courtroom does not launch within 18 months of your payment, you are entitled to a full refund of the $99, regardless of when you ask. We will proactively email you a refund offer at the 18-month mark if we have not launched.</li>
                        <li>Refunds are issued back to the original payment method via Stripe. Stripe processing fees are not retained by us.</li>
                    </ul>

                    <h2 className="font-anton text-2xl uppercase text-white mt-10">Firm-Portal Subscriptions (Starter, Professional, Elite, Enterprise)</h2>
                    <ul className="list-disc pl-6 space-y-2">
                        <li><strong>Monthly plans:</strong> 14-day refund window from your first charge. After 14 days, monthly payments are non-refundable; you may cancel anytime to stop future renewals.</li>
                        <li><strong>Annual plans:</strong> 30-day refund window from the date of charge. After 30 days, annual plans are non-refundable for the remainder of the term. You may cancel to prevent renewal.</li>
                        <li><strong>Cancellations:</strong> Initiated from the Firm Portal &gt; Billing tab or by emailing <a className="text-[#FF3B30] underline" href="mailto:hello@alphacovenantholdings.com">hello@alphacovenantholdings.com</a>. Access continues through the end of the current paid period.</li>
                        <li><strong>Pay-per-lead purchases:</strong> Refundable within 48 hours if the lead turns out to be a duplicate or undeliverable. Otherwise non-refundable once delivered.</li>
                    </ul>

                    <h2 className="font-anton text-2xl uppercase text-white mt-10">Premium User Documents</h2>
                    <p>
                        Document generations (demand letters, expungement guides, premium analyses)
                        are refundable within 7 days if the deliverable has not been viewed,
                        downloaded, or emailed.
                    </p>

                    <h2 className="font-anton text-2xl uppercase text-white mt-10">Free Tier</h2>
                    <p>
                        The core HPM case-submission and 10-bot analysis service is and will
                        remain free. There is nothing to refund on the free tier.
                    </p>

                    <h2 className="font-anton text-2xl uppercase text-white mt-10">How to Request a Refund</h2>
                    <ol className="list-decimal pl-6 space-y-2">
                        <li>Email <a className="text-[#FF3B30] underline" href="mailto:hello@alphacovenantholdings.com">hello@alphacovenantholdings.com</a> from the address you used to purchase.</li>
                        <li>Include your Stripe receipt number or the last 4 digits of the card used.</li>
                        <li>State which product the refund is for.</li>
                        <li>We respond within 2 business days. Approved refunds settle in 5–10 business days at your bank.</li>
                    </ol>

                    <h2 className="font-anton text-2xl uppercase text-white mt-10">Chargebacks</h2>
                    <p>
                        Please contact us before initiating a chargeback. We have never refused a
                        legitimate refund request, and chargebacks cost both sides time and fees.
                    </p>

                    <h2 className="font-anton text-2xl uppercase text-white mt-10">Contact</h2>
                    <p>
                        Higher Power Movement · <a className="text-[#FF3B30] underline" href="mailto:hello@alphacovenantholdings.com">hello@alphacovenantholdings.com</a>
                    </p>
                </div>
            </main>
            <Footer disclaimer="HPM provides legal information, not legal advice. Consult a licensed attorney for legal advice specific to your situation." />
        </div>
    );
}
